import {
  faInfoCircle,
  faPlus,
  faDesktop
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconComponentCard from 'components/common/FalconComponentCard';
import EmptyList from 'components/common/EmptyList';
import AssetTypeRegistrationModal from 'components/modals/AssetTypeRegistrationModal';
import CustomPropertyRegistrationModal from 'components/modals/CustomPropertyRegistrationModal';
import { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Nav,
  OverlayTrigger,
  Tab,
  Tooltip
} from 'react-bootstrap';
import useApi from 'helpers/api';
import CustomFieldsList from './CustomFieldsList';

const CustomFieldsSettings = () => {
  const api = useApi();
  const [assetTypes, setAssetTypes] = useState([]);
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [activeTab, setActiveTab] = useState('assets');
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [showAssetTypeModal, setShowAssetTypeModal] = useState(false);
  const [showAssetFieldModal, setShowAssetFieldModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (activeTab === 'assets') {
      loadAssetTypes();
    }
  }, [activeTab]);

  const loadAssetTypes = async () => {
    const filters = 'page=0&size=1000&includeInactives=false';
    const response = await api.assetTypes.list(filters);

    if (response?.content) {
      setAssetTypes(response.content);
      if (response.content.length > 0 && !selectedAssetType) {
        setSelectedAssetType(response.content[0]);
      }
    }
  };

  const handleAssetTypeChange = e => {
    const assetTypeId = parseInt(e.target.value);
    const assetType = assetTypes.find(at => at.id === assetTypeId);
    setSelectedAssetType(assetType);
  };

  return (
    <>
      <AssetTypeRegistrationModal
        show={showAssetTypeModal}
        close={() => setShowAssetTypeModal(false)}
        refresh={() => loadAssetTypes()}
      />
      <CustomPropertyRegistrationModal
        show={showAssetFieldModal}
        close={() => setShowAssetFieldModal(false)}
        refresh={() => setRefreshKey(prev => prev + 1)}
        entityType="ASSET"
        assetTypeId={selectedAssetType?.id}
        data={null}
        setData={() => {}}
        isCreate={true}
      />
      <CustomPropertyRegistrationModal
        show={showTicketModal}
        close={() => setShowTicketModal(false)}
        refresh={() => setRefreshKey(prev => prev + 1)}
        entityType="TICKET"
        data={null}
        setData={() => {}}
        isCreate={true}
      />
      <FalconComponentCard>
        <FalconComponentCard.Header
          title="Campos Personalizados"
          subTitle="Estenda os dados de Tickets e Ativos com campos adicionais."
        >
          {activeTab === 'assets' &&
            assetTypes.length > 0 &&
            selectedAssetType && (
              <Button
                type="button"
                variant="primary"
                size="sm"
                onClick={() => setShowAssetFieldModal(true)}
              >
                <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
                Novo
              </Button>
            )}
          {activeTab === 'assets' && assetTypes.length === 0 && (
            <Button
              type="button"
              variant="primary"
              size="sm"
              onClick={() => setShowAssetTypeModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
              Novo Tipo de Ativo
            </Button>
          )}
          {activeTab === 'tickets' && (
            <Button
              type="button"
              variant="primary"
              size="sm"
              onClick={() => setShowTicketModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
              Novo
            </Button>
          )}
        </FalconComponentCard.Header>
        <FalconComponentCard.Body>
          <Tab.Container activeKey={activeTab} onSelect={k => setActiveTab(k)}>
            <Nav className="nav-tabs border-0 flex-nowrap mb-3 tab-contact-details">
              <Nav.Item>
                <Nav.Link
                  eventKey="assets"
                  className="d-flex align-items-center py-3 mb-0 text-nowrap"
                >
                  <FontAwesomeIcon icon={faDesktop} className="text-600" />
                  <h6 className="text-600 mb-0 ms-1">Ativos</h6>
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link
                  eventKey="tickets"
                  className="d-flex align-items-center py-3 mb-0 text-nowrap"
                >
                  <FontAwesomeIcon icon="ticket-alt" className="text-600" />
                  <h6 className="text-600 mb-0 ms-1">Tickets</h6>
                </Nav.Link>
              </Nav.Item> */}
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="assets">
                {assetTypes.length > 0 ? (
                  <>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">
                        Selecione o tipo de ativo
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              Escolha o tipo de ativo para gerenciar seus campos
                              personalizados
                            </Tooltip>
                          }
                        >
                          <span className="ms-2 text-info">
                            <FontAwesomeIcon icon={faInfoCircle} />
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Form.Select
                        value={selectedAssetType?.id || ''}
                        onChange={handleAssetTypeChange}
                        size="sm"
                        style={{ maxWidth: '200px' }}
                      >
                        {assetTypes.map(at => (
                          <option key={at.id} value={at.id}>
                            {at.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {selectedAssetType && (
                      <CustomFieldsList
                        key={`asset-${selectedAssetType.id}-${refreshKey}`}
                        entityType="ASSET"
                        assetTypeId={selectedAssetType.id}
                        hasIntegration={selectedAssetType.hasIntegration}
                      />
                    )}
                  </>
                ) : (
                  <EmptyList
                    imgSize={400}
                    vhSize={50}
                    title="Nenhum tipo de ativo cadastrado"
                    description="É necessário ter um tipo de ativo para adicionar campos personalizados"
                  />
                )}
              </Tab.Pane>

              <Tab.Pane eventKey="tickets">
                <CustomFieldsList
                  key={`ticket-${refreshKey}`}
                  entityType="TICKET"
                  hasIntegration={false}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

export default CustomFieldsSettings;
